export const handleWishList = (wishlist, product, dispatch) => {
  if (product?.entity_id in wishlist) {
    dispatch({ type: "remove_wl", payload: product?.entity_id });
  } else {
    dispatch({ type: "add_wl", payload: product });
  }
};
